export const iconSizes = {
    previewControls: {
        light: 20,
        dark: 24
    },
    paginationControls: {
        light: 18,
        dark: 24
    }
} as const;

export const getIconSize = (type: keyof typeof iconSizes, lightMode?: boolean) => {
    const sizes = iconSizes[type];
    return lightMode ? sizes.light : sizes.dark;
};
